 <!-- MODULES -->
 <div style="background-color: white;">
    <div class="row text-center">
      <div class="col-md-12">
        <h2 class="title text-center">Our Core Modules</h2>
        <h5 class="description">RegScale is a composable platform with {{ modules.length }} modules that customers can enable and configure to meet the full scope of their compliance needs.  Start small with only the modules you need with the comfort that you can enable additional modules over time as your compliance needs and process maturity evolves (at no additional cost!).</h5>
      </div>
    </div>
    <div class="row"> 

        <!-- One for each module -->
      <div *ngFor="let m of modules" class="col-md-3">
        <div class="rotating-card-container">
          <div class="card card-rotate h-100">
            <div class="front">
              <div class="card-body text-center">
                <h5 class="card-category card-category-social text-success">
                  <i class="fas fa-clipboard-check fa-2x"></i> 
                </h5>
                <h4 class="card-title">
                  {{ m.name }}
                </h4>
                <p class="card-description">
                  {{ m.description }}
                </p>
              </div>
            </div>
            <div class="back">
              <div class="card-body">
                <h5 class="card-title">
                  Why Does it Matter?
                </h5>
                <p class="card-description">
                  {{ m.impact }}
                </p>
                <div class="footer text-center">
                  <a href="#pablo" class="btn btn-rose btn-round">
                    <i class="material-icons">subject</i> Learn More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
    </div>
  </div>
